import React from "react";
import styled from "styled-components";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import InternalSign from "../../Images/internal.svg";

const StyledLabel = styled.label`
  color: #535559;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
`;
const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;
  padding: 12px;
  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  input[type="checkbox"] {
    accent-color: #ff5837;
  }
  .manual_text {
    width: 250px;
  }
`;
const OtherInfo = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <FormContainer className="row g-3">
      <h2
        className="me-1 mb-1 "
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          color: "#323B4B",
          fontWeight: 600,
        }}
      >
        Sales
      </h2>
      <div className="col-12 row mx-0 px-0 align-items-center">
        <StyledLabel className="form-label">
          SalesPerson
          <img className="ms-2" src={InternalSign} alt="internalSign" />
        </StyledLabel>
        <div className="col-6 px-2">
          <input className="form-control" type="text" />
        </div>
        <div className="col-6">
          <input className="ms-2" type="checkbox" /> Process Manual Confirm
        </div>
      </div>
      <div className="col-12 row mx-0 px-0 align-items-center">
        <StyledLabel className="form-label">
          Sales Team
          <img className="ms-2" src={InternalSign} alt="internalSign" />
        </StyledLabel>
        <div className="col-6 px-2">
          <input className="form-control" type="number" />
        </div>
        <div className="col-6 row">
          <div className="col-6">
            <input className="ms-2" type="checkbox" /> Online Signature
          </div>
          <div className="col-6">
            <input className="ms-2" type="checkbox" /> Online Payment
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <StyledLabel className="form-label">Customer Reference</StyledLabel>
        <input className="form-control" type="number" />
      </div>
      <div className="col-md-6">
        <StyledLabel className="form-label">Tags</StyledLabel>
        <input type="text" className="form-control" />
      </div>
      <h2
        className="me-1 mb-1 "
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          color: "#323B4B",
          fontWeight: 600,
        }}
      >
        Invoicing
      </h2>
      <div className="col-md-6">
        <StyledLabel className="form-label">Fiscal Position</StyledLabel>
        <input className="form-control" type="number" />
      </div>
      <h2
        className="me-1 mb-1 "
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          color: "#323B4B",
          fontWeight: 600,
        }}
      >
        Delivery
      </h2>
      <div className="col-md-6">
        <StyledLabel className="form-label">Shipping Policy</StyledLabel>
        <input className="form-control" type="number" />
      </div>
      <div className="col-md-6">
        <StyledLabel className="form-label">Delivery Date</StyledLabel>
        <input type="text" className="form-control" />
      </div>
    </FormContainer>
  );
};

export default OtherInfo;
